/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Swiper */
import { SwiperClass } from "swiper/react";

/* Components */
import Cohort from "src/components/shared/swiper/swiper-controls/cohort/Cohort";
import BulletContainer from "src/components/shared/swiper/swiper-controls/bullet-container/BulletContainer";

/* Stylesheet */
import styles from "./SwiperControls.module.scss";

/* Interfaces */
interface SwiperControlsProps {
  scssProps?: ScssProps;
  swiperInstance?: SwiperClass | null;
  stacked: boolean;
  pagination?: React.ReactNode;
  length: number;
  activeIndex: number;
  name?: string | undefined;
  currentPage?: number;
  handlePrevPage?: () => void;
  handleNextPage?: () => void;
}

interface ScssProps {
  padding?: string;
  height?: string;
  backgroundColor?: string;
}

const SwiperControls: React.FC<SwiperControlsProps> = ({
  scssProps,
  swiperInstance,
  stacked,
  pagination,
  length,
  activeIndex,
  name,
}) => {
  const { padding, height, backgroundColor } =
    scssProps || {};

  return (
    <IonGrid
      style={{
        padding: padding,
        height: height,
        background: backgroundColor,
      }}
      className={styles.swiper_controls}
    >
      <IonRow className={styles.row}>
        <IonCol className={`${styles.col}`} size="2">
          {name !== undefined ? (
            <Cohort name={name} />
          ) : undefined}
        </IonCol>
        <IonCol
          className={`${styles.col} ${styles.bullet_container_col}`}
          size="8"
        >
          {length > 1 && stacked ? (
            <BulletContainer
              swiperInstance={swiperInstance}
              length={length}
              activeIndex={activeIndex}
            />
          ) : undefined}
        </IonCol>
        <IonCol
          className={`${styles.col} ${styles.pagination_col}`}
          size="2"
        >
          {pagination}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default SwiperControls;
